/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_MatchedInputs */

const en_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const de_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const fr_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const es_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const it_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const nl_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const pl_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const fi_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const da_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const sv_portal_scanner_matched = /** @type {(inputs: Portal_Scanner_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

/**
* | output |
* | --- |
* | "Matched" |
*
* @param {Portal_Scanner_MatchedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_matched = /** @type {((inputs?: Portal_Scanner_MatchedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_MatchedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_matched(inputs)
	if (locale === "fr") return fr_portal_scanner_matched(inputs)
	if (locale === "es") return es_portal_scanner_matched(inputs)
	if (locale === "it") return it_portal_scanner_matched(inputs)
	if (locale === "nl") return nl_portal_scanner_matched(inputs)
	if (locale === "pl") return pl_portal_scanner_matched(inputs)
	if (locale === "fi") return fi_portal_scanner_matched(inputs)
	if (locale === "da") return da_portal_scanner_matched(inputs)
	if (locale === "sv") return sv_portal_scanner_matched(inputs)
	return en_portal_scanner_matched(inputs)
});